var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { CART_OPTION } from '@/stores/defs';
import EventBus from '@EventBus';
var addToCartMixin = {
    data: function () {
        return {
            quantityNameMap: {
                none: 0,
                light: 0.5,
                regular: 1,
                extra: 2,
            },
        };
    },
    computed: __assign({}, mapGetters({
        getChoiceQuantity: CART_OPTION.GET_CHOICE_QUANTITY,
    }), { hasImage: function () {
            var choice = this.choice;
            return !!this.hasMenuImage(choice);
        },
        getImageURL: function () {
            var choice = this.choice;
            return this.getMenuImage(choice);
        } }),
    methods: __assign({}, mapActions({
        removeChoice: CART_OPTION.REMOVE_CHOICE,
        setChoiceQuantity: CART_OPTION.SET_CHOICE_QUANTITY,
        setChoiceDivision: CART_OPTION.SET_CHOICE_SIBLING,
    }), { choiceToggle: function (choice) {
            if (this.getChoiceQuantity(choice)) {
                this.setChoiceQuantityWrapper({ choice: choice, quantity: 0 });
            }
            else {
                this.setChoiceQuantityWrapper({ choice: choice, quantity: 1 });
                this.openToggle = true;
            }
            EventBus.$emit('updateChoice', choice);
        },
        choiceAction: function (params) {
            if (params.quantity === 0) {
                this.setChoiceDivision({
                    choice: params.choice,
                    siblingId: '0',
                });
            }
            this.setChoiceQuantityWrapper(params);
            EventBus.$emit('updateChoice', params.choice);
        },
        setChoiceQuantityWrapper: function (_a) {
            var choice = _a.choice, quantity = _a.quantity;
            this.openToggle = (quantity > 0) ? true : false;
            this.setChoiceQuantity({
                choice: choice,
                quantity: quantity,
            });
        },
        getQuantity: function () {
            var quantity = this.getChoiceQuantity(this.choice);
            this.openToggle = (quantity > 0) ? true : false;
            return "" + quantity;
        },
        resolveQuantity: function (type) {
            var quantity = +this.getQuantity();
            var predicate = (quantity === 0);
            if (type === 'regular') {
                predicate = (quantity === 1);
            }
            else if (type === 'extra') {
                predicate = (quantity >= 2);
            }
            else if (type === 'light') {
                predicate = (quantity < 1 && 0 < quantity);
            }
            return predicate ? 'selected' : '';
        },
        isSelected: function () {
            var quantity = +this.getQuantity();
            if (quantity > 0) {
                return 'choice-selected';
            }
            return '';
        },
        hasDivisions: function () {
            var divisible = this.option.isDivisible;
            return (divisible) ? 'choice-row--divisible' : '';
        },
        toggleChoiceRow: function () {
            if (this.openToggle) {
                return 'open';
            }
            return '';
        } }),
};
export default addToCartMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/choiceActionMixin.ts
// module id = Tb1L
// module chunks = 18